import React, { useState } from 'react';

const PDFViewer = ({ url }) => {
  const [error, setError] = useState(false);

  if (error) {
    return (
      <div className="viewer-overlay viewer-error">
        <i className="material-icons">picture_as_pdf</i>
        <p>Impossible d'afficher le PDF dans le navigateur.</p>
        <a href={url} target="_blank" rel="noreferrer" className="btn btn-outline-primary btn-sm">
          Ouvrir dans un nouvel onglet
        </a>
      </div>
    );
  }

  return (
    <iframe
      src={url}
      className="pdf-viewer-frame"
      title="Aperçu PDF"
      onError={() => setError(true)}
    />
  );
};

export default PDFViewer;
